import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Append "Library" to a library name if it doesn't already contain it.
 * e.g. "Tomtiko" → "Tomtiko Library", "LagosLibrary" → "LagosLibrary"
 */
export function formatLibraryName(name: string): string {
  return /library/i.test(name) ? name : `${name} Library`;
}
